import React, {useState} from 'react';

import { Modal } from '../../components';

import './modal-custom-category.css';

const ModalCustomCategory=({
  isOpen,
  onCancel,
  onSave
})=>{

  const [cat,setCat]=useState('');
  const [error,setError]=useState('');

  const onChange=({target:{value}})=>{
    if(value) {
      setError('');
    }
    setCat(value);
  }

  const onSaveLocal=()=>{
    if(!cat) {
      setError('Empty category not allowed!');
      return true;
    }
    setError('');
    onSave(cat);
  }

  let errorHtml=false;
  if(error) {
    errorHtml=<span className="error-msg">{error}</span>
  }

  return (
    <Modal isOpen={isOpen} onClose={onCancel} className="modal-content-default add-category-modal">
      <div className="font-color2">
        <h2>
          New Custom Category: 
          <input type="text" className="textfield1" value={cat} onChange={onChange} />
          {errorHtml}
        </h2>
        <div className="modal-controls">
          <button className="btn btn-default-cancel" onClick={onCancel} type="button">Cancel</button>
          <button className="btn btn-default-ok" onClick={onSaveLocal} type="button">Save</button>
        </div>
      </div>
    </Modal>
  )

}


export default ModalCustomCategory;